import React from 'react';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';

const generateSOAConfirmation = (
  isLoading,
  isStartAssessment,
  transactionStatus,
  applicationStatus,
  hasGeneratedSOA,
  onYesCallBack,
  onNoCallback = () => {}
) => {
  const isStatusAllowed = ['FOR CHECKING'].indexOf(transactionStatus) > -1;

  const isApplicationStatusAllowed =
    ['FOR LICENSE ASSESSMENT'].indexOf(applicationStatus) > -1;

  const isAllowed = true && isStatusAllowed;

  const showComponent =
    isAllowed &&
    isStartAssessment &&
    isApplicationStatusAllowed &&
    !hasGeneratedSOA;

  const onHandleClick = (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure you want to generate SOA for this application?`,
      onYesCallBack,
      onNoCallback,
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const component = showComponent ? (
    <button
      disabled={isLoading}
      onClick={onHandleClick}
      type="button"
      className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold   "
    >
      {isLoading && (
        <>
          <i className="fas fa-spinner fa-spin" />
          &nbsp;
        </>
      )}
      Generate SOA
    </button>
  ) : null;

  return {
    isAllowed,
    onHandleClick,
    component,
  };
};

export default generateSOAConfirmation;
